const namespace = 'authentication';
const missingDataNamespace = `${namespace}.missingData`;
const redirectFailedNamespace = `${namespace}.redirectFailed`;
const sessionLostNamespace = `${namespace}.sessionNotAuthenticated`;
const notTraderNamespace = `${namespace}.userNotTrader`;
const missingSobNamespace = `${namespace}.missingSob`;
const missingAuthorityNamespace = `${namespace}.missingAuthority`;
const badCredentialsNamespace = `${namespace}.badCredentials`;
const emailBlockedNamespace = `${namespace}.emailBlocked`;
const userUnblockNamespace = `${namespace}.userUblock`;
const captchaBlockedNamespace = `${namespace}.captchaBlocked`;
const authTanRequestNamespace = `${namespace}.authTanRequest`;
const userConfigNamespace = `${namespace}.userConfig`;
const sendPassEmail = `${namespace}.sendPassEmail`;
const smsTanValidationNamespace = 'smsTanValidation';

const i18n = {
  SEND_PASS_EMAIL: {
    TITLE: {
      key: `${sendPassEmail}.title`,
      message: `Send Set Password Email`,
    },
  },
  SENDED_PASS_EMAIL: {
    TITLE: {
      key: `${sendPassEmail}.title`,
      message: `The recover password was sent to the user`,
    },
  },
  WRONG_PASSWORD_ON_CHANGE_PASSWORD: {
    TITLE: {
      key: `${missingDataNamespace}.wrongPasswordOnChangePasswordTitle`,
      message: 'Wrong combination',
    },
    DESCRIPTION: {
      key: `${missingDataNamespace}.wrongPasswordOnChangePasswordTitleDescription`,
      message: 'Please verify our data and try again',
    },
  },
  MISSING_DATA: {
    TITLE: {
      key: `${missingDataNamespace}.title`,
      message: 'Missing Data',
    },
    DESCRIPTION: {
      key: `${missingDataNamespace}.description`,
      message:
        'Application was not able to detect required data for authentication.',
    },
    EXPLANATION: {
      key: `${missingDataNamespace}.explanation`,
      message: 'Please, try to navigate directly to desired application URL.',
    },
  },
  REDIRECT_FAILED: {
    TITLE: {
      key: `${redirectFailedNamespace}.title`,
      message: 'Redirect Failed',
    },
    DESCRIPTION: {
      key: `${redirectFailedNamespace}.description`,
      message: 'Failed to redirect to the application url',
    },
    INVALID_URL: {
      key: `${redirectFailedNamespace}.invalidUrl`,
      message: 'Invalid application url',
    },
  },
  SESSION_NOT_AUTHENTICATED: {
    TITLE: {
      key: `${sessionLostNamespace}.title`,
      message: 'Session Not Authenticated',
    },
    DESCRIPTION: {
      key: `${sessionLostNamespace}.description`,
      message: 'You are not logged in or your session was considered inactive.',
    },
    EXPLANATION: {
      key: `${sessionLostNamespace}.explanation`,
      message:
        'You will have to login again in order to continue and access successfully. If you are experiencing issues, please contact us.',
    },
  },
  USER_NOT_TRADER: {
    TITLE: {
      key: `${notTraderNamespace}.title`,
      message: 'You have no access',
    },
    DESCRIPTION: {
      key: `${notTraderNamespace}.description`,
      message:
        'Sorry, but the user you are accessing from is not a valid retailer.',
    },
    EXPLANATION: {
      key: `${notTraderNamespace}.explanation`,
      message:
        'You will have to login with a different account in order to continue and access successfully. If you are experiencing issues, please contact us.',
    },
  },
  USER_MISSING_SOB: {
    TITLE: {
      key: `${missingSobNamespace}.title`,
      message: 'You have no access',
    },
    DESCRIPTION: {
      key: `${missingSobNamespace}.description`,
      message:
        'Sorry, but your store doesnt have a relationship with this brand.',
    },
    EXPLANATION: {
      key: `${missingSobNamespace}.explanation`,
      message:
        'You will have to login with a different account or request for access in order to continue and access successfully. If you are experiencing issues, please contact us.',
    },
  },
  USER_MISSING_AUTHORITY: {
    TITLE: {
      key: `${missingAuthorityNamespace}.title`,
      message: 'You have no access',
    },
    DESCRIPTION: {
      key: `${missingAuthorityNamespace}.description`,
      message: 'Sorry, but your user has no access to this application.',
    },
    EXPLANATION: {
      key: `${missingAuthorityNamespace}.explanation`,
      message:
        'Please contact us. This error means your user does not have the specific permission needed for the access you are requesting.',
    },
  },
  BAD_CREDENTIALS: {
    TITLE: {
      key: `${badCredentialsNamespace}.title`,
      message: 'Bad Credentials',
    },
    DESCRIPTION: {
      key: `${badCredentialsNamespace}.description`,
      message:
        'Your credentials do not match. Please check if the combination used is correct.',
    },
    // EXPLANATION: {
    //   key: `${badCredentialsNamespace}.explanation`,
    //   message: '',
    // },
  },
  EMAIL_BLOCKED: {
    TITLE: {
      key: `${emailBlockedNamespace}.title`,
      message: 'Account Blocked',
    },
    DESCRIPTION: {
      key: `${emailBlockedNamespace}.description`,
      message: 'Your account is now blocked due to too many attempts.',
    },
    REQUEST_UNBLOCK_ERROR: {
      key: `${userUnblockNamespace}.requestUnblockError`,
      message: 'User unblock request error',
    },
    SEND_MAIL_SUCCESS_TITLE: {
      key: `${userUnblockNamespace}.sendMailSuccessTitle`,
      message: 'Account unblock request success',
    },
    UNBLOCK_SUCCESS: {
      key: `${userUnblockNamespace}.userUnblockSuccess`,
      message: 'User was successfully unblocked, you can now login normally',
    },
    UNBLOCK_ERROR: {
      key: `${userUnblockNamespace}.userUnblockError`,
      message:
        'Unblock didnt work, check if your account was already unblocked or you received multiple e-mails with different links.',
    },
    EXPLANATION: {
      key: `${emailBlockedNamespace}.explanation`,
      message:
        'You will receive an e-mail right now with instructions on how to unblock your account.',
    },
    ACTION: {
      key: `${emailBlockedNamespace}.action`,
      message: 'Unblock my account',
    },
  },
  CAPTCHA_BLOCKED: {
    TITLE: {
      key: `${captchaBlockedNamespace}.title`,
      message: 'Captcha Required',
    },
    DESCRIPTION: {
      key: `${captchaBlockedNamespace}.description`,
      message:
        'You must inform captcha in order to proceed. Due to too many attempts, your next attempts are protected.',
    },
    // EXPLANATION: {
    //   key: `${captchaBlockedNamespace}.explanation`,
    //   message: '',
    // },
  },
  AUTH_TAN_REQUEST: {
    TITLE: {
      key: `${authTanRequestNamespace}.title`,
      message: 'Verification Code',
    },
    REQUEST_ERROR: {
      key: `${authTanRequestNamespace}.description`,
      message:
        'Error while sending TAN code. Please check your email and try again.',
    },
    REQUEST_SUCCESS: {
      key: `${authTanRequestNamespace}.requestSuccess`,
      message: 'Succefully requested TAN Code',
    },
    RESEND_CODE: {
      key: `${authTanRequestNamespace}.resendCode`,
      message: 'Resend code',
    },
    // EXPLANATION: {
    //   key: `${authTanRequestNamespace}.explanation`,
    //   message: '',
    // },
  },
  SMS_VALIDATION: {
    DESCRIPTION: {
      key: `${smsTanValidationNamespace}.registerNumDesc`,
      message:
        'To protect your data, we need to send a code to your phone. Please enter your telephone number',
    },
    DUPLICATED_NUMBER: {
      key: `${smsTanValidationNamespace}.phoneAlrewadyInUse`,
      message: 'This phone is not available for verification. Already in use',
    },
  },
  USER_CONFIG: {
    NOT_FOUND: {
      key: `${userConfigNamespace}.notFound`,
      message: 'User Not Found',
    },
    VERIFIED_IDENTITY: {
      key: `${userConfigNamespace}.verifiedIdentity`,
      message: 'Verified Identity',
    },
    IDENTITY_NOT_VERIFIED: {
      key: `${userConfigNamespace}.identityNotVerified`,
      message: 'Not Verified',
    },
    // EXPLANATION: {
    //   key: `${authTanRequestNamespace}.explanation`,
    //   message: '',
    // },
  },
  DATA_PRIVACY: {
    key: `${namespace}.dataPrivacy`,
    message: `
<strong>Data privacy</strong>
<br />
As the operator of THE Jura POS SupportApp, the public limited company “marken mehrwert - brand added value AG”, Julius Hatry Str. 1, 68163 Mannheim, Email: kontakt@mmw.ag is responsible for the personal data (see also imprint) of the user of the website according to Article 4 paragraph 7 of the EU General Data Protection Regulation (GDPR). Our Data Protection Officer is available by email under “datenschutz@mmw.ag” or under the postal address with the addition “Data Protection Officer”.
<br />
We protect your privacy and your private data. We collect, process and use your personal data in accordance with the content of this Privacy Statement as well as the applicable European and German provisions of the Data Protection Act.
<br />
This Privacy Statement governs the extent to which we collect, process and use personal data about you. We therefore request you to read it carefully in the following.
<br />
This statement concerning the privacy of data applies solely to our own Internet presence. The web pages of this site may contain links to third-party websites. Our Privacy Statement does not extend to these web pages. When you leave our website, it is recommended that you read the privacy statement of each website carefully that collects personally identifiable information.
<br />
By agreeing to the following Privacy Statement, you consent to us collecting, processing and using your personal data in compliance with the applicable data protection provisions and the following regulations.
<br />
<strong>1 Collection of data</strong>
<br />
<strong>1.1 Informative use of the website</strong>
<br />
Every time you access a page of our website and every time a file is accessed, access data about this procedure is stored in a log file on the respective server. These are in particular the following information:
<br />
date and time of the request time zone difference to Greenwich Mean Time (GMT) content of the request (specific page) access status/HTTP status code the amount of data the requesting website the browser operating system and its interface language and version of the browser software IP address
<br />
The IP address of your computer is stored only for the time that you use the website and then immediately deleted or anonymised by curtailment.We collect the aforementioned data as this is technically necessary for us to be able to show you our website and to ensure the stability and security of the website. The legal basis for this is Article 6 paragraph 1 clause 1 point f) GDPR.
<br />
<strong>1.2 Provision of personal data</strong>
<br />
Insofar as you use our website other than just for information purposes, you generally need to specify other personal data, e.g. last name, date of birth, address, mailing address or telephone number, which we use to provide the respective services. The corresponding personal data are collected by us only if this is permitted by law (e.g. for the execution of a contract, Article 6 paragraph 1 clause 1 point b) GDPR, or in the case of a legitimate interest, Article 6 paragraph 1 clause 1 point f) GDPR, or you consent to the collection of data, Article 6 paragraph 1 clause 1 point a) GDPR.
<br />
You may revoke your consent given to process your personal data at any time. A corresponding revocation has a direct influence on the admissibility of processing of your personal data, as soon as this has been given to us.
<br />
If the processing of your personal data is based on a balance of interests, you may object to the processing. If you exercise your right of objection, we kindly ask you to explain the reasons why we should not process your personal data. If your objection is justified, we will review the facts and stop and/or adjust the data processing or inform you of compelling legitimate reasons why we continue the processing.
<br />
We will delete your personal information as soon as it is no longer necessary for the respective purpose. It may happen that personal data is retained for the time in which claims can be asserted against us (e.g. statutory limitation period of three or thirty years). In addition, we are required by law to save certain data due to our obligations to provide evidence and keep records, including those according the German Commercial Code, the German Tax Code or the Money Laundering Act. The storage periods may be up to ten years.
<br />
<strong>1.2.1 Data for the newsletter service</strong>
<br />
The newsletter service will inform you by email or by post about our own range of services. Furthermore, you can also receive information about offers from specific manufacturers by email or post. For this purpose, your consent is necessary.
<br />
The so-called double opt-in procedure is used for sending newsletters, i.e. you will not receive a newsletter until you have explicitly confirmed that the newsletter service is to be activated.
<br />
You will then receive a confirmation email and you will be asked to confirm that you wish to receive newsletters by clicking on a link in this email.
<br />
If you do not confirm the registration within 24 hours, we will immediately block your information and delete it automatically after one month. In addition, we only store your IP address and the time of registration and confirmation in order to be able to prove your registration and the possibility to clarify misuse of your data.
<br />
You only have to enter your email address in order to receive newsletters. The provision of further data is voluntary. We will only save your email address for the purpose of sending our newsletter. The legal basis for this is Article 6 paragraph 1 clause 1 point a) GDPR.
<br />
If you no longer wish to receive a newsletter later on, you can revoke your consent at any time and cancel your subscription to the newsletter. A message in text form to the contact data mentioned (e.g. email, letter) is sufficient for this. Of course, an unsubscribe link is also to be found in every newsletter via email.
<br />
<strong>1.2.2 User account</strong>
<br />
When setting up an account to use our services, e.g. to participate in promotions of the manufacturers associated with us, your data may be stored permanently and/or for the period of a promotion in the user database. If you want to use the services, you must provide personal data in order to conclude the contract. The mandatory information required for the use of the services (e.g. name, email address, date of birth, telephone number) are marked accordingly and will be processed for this purpose. The legal basis for this can be found in Article 6 paragraph 1 clause 1 point b) GDPR.
<br />
You are bound to treat the personal access data confidentially and not to make it accessible to unauthorised third parties. We cannot accept any liability for abuse of passwords, unless we are responsible for such improper use. You should notify us immediately if you are concerned that a third party has become aware of your password or is using the password in an unauthorised way or is likely to do so. You are responsible for ensuring that your information is accurate and complete and that you notify us of any changes to the information you have provided.
<br />
You can view and update any information you have provided to us, as well as your account settings in the ‘My User Account’ section of the website. After you have finished communicating with MMW Services, you should log out and close the browser window, especially if you are sharing the computer with other people.
<br />
In order to prevent violating the conditions of participation in promotions and/or to detect fraud, various algorithms (mathematical-statistical methods) are used. The results of the evaluations will be checked by us again and assessed accordingly. A transfer of personal data to third parties does not take place in this context.
<br />
If you participate in the marketing survey of the respective manufacturers during the registration process, this data will not be stored on a personal basis.
<br />
Storage of the data provided as part of registration can be revoked at any time. The data provided and your entire user account can always be deleted in the customer area.
<br />
Due to commercial and tax regulations, we are obliged to save your address, payment and order data for a period of at least 10 years. However, after 3 years after placing an order, we restrict the use of the relevant data, with the consequence that they may only be used to comply with legal obligations.
<br />
<strong>1.2.3 Data transmission by business partners</strong>
<br />
In case we receive personal data from third parties (e.g. business partners), for example, for processing promotions, these will also only be used in compliance with the data protection laws and this privacy policy.
<br />
<strong>1.2.4 Uploads</strong>
<br />
For consumers and dealers, the possibility exists to upload documents from us (e.g. receipts, invoices, etc.). The personal data contained herein are also only used in compliance with the data protection laws and this privacy policy.
<br />
<strong>1.2.5 Chat</strong>
<br />
In our chat, you have the opportunity to contact us directly if you have questions about our range of services. Your IP address will be anonymised according to the legal regulations. The chat history is saved anonymously and evaluated. In order to participate, you must give your email address and additionally either your name or a pseudonym.
<br />
We reserve the right to terminate chats where insults are made, or which are offensive, racist, or otherwise illegal, unlawful, or are in breach of our business terms and conditions, and to block users in the event of particularly serious violations. The legal basis is Article 6 paragraph 1 clause 1 point b) and point f) GDPR.
<br />
<strong>1.2.6 Contact form and/or contact by email or fax</strong>
<br />
If you contact us via the contact form on our website or by email or fax, the information you provide will be stored and processed in order to handle the request, as well as in the case that follow-up questions should arise. We delete the respective data, after storage is no longer required or limit its processing, insofar as legal retention periods exist. The legal basis is Article 6 paragraph 1 clause 1 point a), point b) and point f) GDPR.
<br />
<strong>2 Transfer of data</strong>
<br />
We do not share your personal data with third parties, unless you have consented to this data transfer or this is necessary for the purpose of executing the contract, or we are entitled or obliged to a data transfer due to statutory provisions and/or official or judicial orders.
<br />
We partly use external service providers to process your personal data. These have been carefully selected and commissioned by us. They are bound by our instructions and are regularly inspected. The data provided to our service providers may only be used by them to fulfil their tasks. No personal data will be transferred to third parties outside the European Economic Area (EEA).
<br />
<strong>2.1 Disclosure to process promotions</strong>
<br />
The data collected by us will be forwarded to the transport companies commissioned with delivery as part of the processing of dispatching promotions, as far as this is necessary for the delivery of the goods. The legal basis is Article 6 paragraph 1 clause 1 point b) GDPR.
<br />
<strong>2.2 Disclosure to the organiser of the promotions</strong>
<br />
In order to fulfil the purpose of the contract, it may be necessary to transfer personal data from customers or dealers to the organisers of the promotions. Otherwise, the data related to the contract or the processing of the promotion is forwarded in the context of anonymous reports to the organiser of the promotion and used in particular for statistical purposes. The legal basis is Article 6 paragraph 1 clause 1 point b) GDPR.
<br />
<strong>2.3 Transfer for payment purposes</strong>
<br />
We forward your payment data as part of the processing of payments to the commissioned credit card company and/or PayPal or the respective payment service provider. Insofar as you, as a customer, have registered with your customer account, you have the option to deposit a certain type of payment for further purchases. The legal basis is Article 6 paragraph 1 clause 1 point b) GDPR.
<br />
<strong>2.4 Disclosure for the sending of newsletters</strong>
<br />
Your consent to the sending of newsletters (section 1.2.1), you also agree that your email address or address be forwarded to certain manufacturers whose newsletter you will receive. A corresponding note in this respect can also be found in the confirmation email. The legal basis is Article 6 paragraph 1 clause 1 point a) GDPR.
<br />
<strong>3 Cookies</strong>
<br />
In addition to the aforementioned user data, cookies are stored on your computer when you use our website. These are small text files that are stored on your device and through which we receive certain information. However, cookies cannot execute programs or transmit viruses to your computer. We use cookies to make calling on our website attractive and to enable the use of certain functions.
<br />
We use transient and persistent cookies on our website. If you close your browser, transient cookies are automatically deleted.
<br />
These cookies also include in particular session cookies. These allow your computer to recognise when you return to our website. Session cookies are deleted as soon as you close the browser or log out.
<br />
In contrast, persistent cookies are automatically deleted after a specified period of time. These cookies can be deleted at any time in the security settings of your browser.
<br />
Basically, you can configure your browser settings according to your wishes and e.g. reject all cookies. However, non-acceptance of cookies may limit the functionality of our website. With flash cookies which we also use, a record is not made via your browser, but through your flash plug-in. We also use HTML5 storage objects, which are stored on your terminal device. Data is stored independently of your browser and does not have an automatic expiration date. Insofar as processing of flash cookies is not desired, you must install an appropriate add-on, e.g. “Better Privacy” (Mozilla Firefox) or “Adobe Flash Killer Cookie” (Google Chrome). If you want to prevent the use of HTML5 storage objects, you must use the private mode in your browser. In addition, we recommend that you delete your cookies and the browser history at regular intervals.
<br />
<strong>4 Google Analytics</strong>
<br />
This website uses Google Analytics, a web analytics service provided by Google Inc. (“Google”). Google Analytics uses so-called “Cookies”, text files stored on your computer which allow an analysis of your use of the website. The information generated by the cookie about your use of this website is usually transmitted to a Google server in the USA and stored there. However, if IP anonymization is enabled on this site, Google will truncate your IP address beforehand within the Member States of the European Union or in other treaties of the European Economic Area Agreement. Only in exceptional cases will the full IP address transmitted to a Google server in the USA and shortened there. On behalf of the operator of this website, Google will use this information to evaluate your use of the website, to compile reports on the website promotions and to provide other services related to website usage and internet usage to the website operator. The IP address transmitted by Google Analytics as part of Google Analytics will not be merged with other Google data. You can prevent the storage of cookies by a corresponding setting of your browser software; however, please be aware that in this case you may not be able to use all features of this website to its full extent. In addition, you may prevent the collection by Google of the data generated by the cookie and related to your use of the website (including your IP address) as well as the processing of this data by Google by downloading and installing the browser plug-in available under the following link: http://tools.google.com/dlpage/gaoptout?hl=de. This website uses Google Analytics with the extension „_anonymizeIp()“.As a result, IP addresses are processed shortened, a reference to persons can thus be excluded. Insofar as the data relating to you is assigned a personal reference, it will be excluded and the personal data will be deleted immediately. We use Google Analytics to analyse and regularly improve the use of our website. By using the statistics obtained, we can improve our range of services and make them more interesting for you as a user. In the exceptional cases where personal information is transferred to the US, Google is subject to the EU-US Privacy Shield, https://www.privacyshield.gov/EU-US Framework. The legal basis for the use of Google Analytics is Article 6 paragraph 1 clause 1 point f) GDPR. Third-party information: Google Dublin, Google Ireland Ltd., Gordon House, Barrow Street, Dublin 4, Ireland, Fax: +353 (1) 436 1001. Terms of Use: http://www.google.com/analytics/terms/de.html, Overview of the Privacy Policy: http://www.google.com/intl/de/analytics/learn/privacy.html, as well as the Privacy Policy: http://www.google.com/intl/en/policies/privacy. This site also uses Google Analytics for cross-device analysis of flows of visitors which are carried out via a user ID. You can deactivate your use of the cross-device analysis in your customer account under “My data”, “Personal data”.
<br />
<strong>6 Data security</strong>
<br />
We take all appropriate technical and organisational security measures to protect your data from manipulation, loss, destruction or unauthorised access by third parties. Our systems are protected against unauthorised access. In particular, your personal data is transmitted in an encrypted form. We use the coding system SSL (Secure Socket Layer) for this.
<br />
We wish to expressly point out that despite all technical precautions, the Internet does not permit absolute data security. We are not liable for acts of third parties.
<br />
<strong>7 Change of privacy policy</strong>
<br />
We reserve the right to change this Privacy Policy at any time with an effect for the future. A current version is always available on the website. Please visit the website regularly to find out about the currently valid privacy policy.
<br />
<strong>8 Rights</strong>
<br />
You have the right to access, rectify or delete, limit the processing, object to processing and data portability of your personal data that we have collected about you.
<br />
For respective requests and/or communications from users, we are available under the address details mentioned.
<br />
We also wish to point out that the deletion of user data is only possible if there are no legal regulations which contradict this.
<br />
Information shall always be transmitted in electronic form (by email). Should you exercise this option of providing information via email, the specified email address (for both sender and recipient) shall not be used for any other purpose than to provide information and its documentation.
<br />
You also have the right to lodge a complaint to a supervisory authority for data privacy about the way we process your personal data.
<br />
If we are legally required to disclose data to local, state, national or international authorities, we shall comply with this obligation.
<br />
We will also disclose information to third parties if required to do so by applicable laws and regulations.
<br />
In addition, we may disclose information to investigate, prevent or initiate corresponding countermeasures against any illegal activity or suspected fraud, or to enforce or assert our contracts and licensing rights.
<br />
<strong>9 Contact</strong>
<br />
If you have any questions, comments or inquiries regarding the collection, processing and use of your personal data by us, please contact us using the following contact details.
<br />
<strong>Address</strong>
<br />
mehrwert – brand added value AG
Mafinex Technologiezentrum
Julius Hatry Str. 1
68163 Mannheim
VAT ID No. DE258032509
Court of registration Mannheim HRB 704123

<strong>Contact</strong>
<br />
E-Mail: datenschutz@mmw.ag
www.mmw.ag
<br />
<strong>Legals</strong>
<br />
General terms and Conditions
Imprint
Privacy Statement
Board of Directors: Frank Schwarz
Supervisory Board (Chairman): Prof. Dr. Stefan Jugel
Members of the Supervisory Board: Prof. Dr. Gerald Graf, Prof. Dr. Dietmar von Hoyningen-Huene
  `,
  },
  MMW_LOGIN: {
    REDIRECTING: {
      TITLE: {
        key: `${namespace}.redirectingTitle`,
        message: 'Redirecting...',
      },
      MESSAGE: {
        key: `${namespace}.redirectingMessage`,
        message: 'You will be redirected soon',
      },
    },
    LOGIN_WITH_GOOGLE: {
      key: `${namespace}.loginWithGoogle`,
      message: 'Trying to loggin using google credentials',
    },
    LOGOUT: {
      LABEL: {
        key: `${namespace}.logout`,
        message: 'Logout',
      },
      FROM_ALL_APPLICATIONS: {
        key: `${namespace}.logoutFromAllApplications`,
        message: 'Logging out from all applications',
      },
    },
  },
};

export const {
  MISSING_DATA,
  SESSION_NOT_AUTHENTICATED,
  USER_NOT_TRADER,
  USER_MISSING_SOB,
  BAD_CREDENTIALS,
  EMAIL_BLOCKED,
  CAPTCHA_BLOCKED,
  AUTH_TAN_REQUEST,
  USER_CONFIG,
  DATA_PRIVACY,
  MMW_LOGIN,
  WRONG_PASSWORD_ON_CHANGE_PASSWORD,
  SEND_PASS_EMAIL,
  SENDED_PASS_EMAIL,
  SMS_VALIDATION,
} = i18n;

export default i18n;
